import { i18n } from '@/i18n';

export function validateMobile(rule, value, callback) {
  if (value === '') {
    callback(new Error('Please input mobile'));
  } else {
    const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
    if (!reg.test(value)) {
      callback(new Error(i18n.global.t('login.REGISTER.inputcorrectmobile')));
    } else {
      callback();
    }
  }
}

export function validateUsername(rule, value, callback) {
  if (value === '') {
    callback(new Error(i18n.global.t('login.REGISTER.inputusername')));
  } else {
    const reg = /^([A-Za-z])([A-Za-z\d@_\-.]){6,29}/g;

    if (!(reg.test(value) && value.length <= 30)) {
      callback(
        new Error(
          '用户名为6-30个字符，首字符必须是英文字母，只能包含：英文字母数字、字符(@_-.)',
        ),
      );
    } else {
      callback();
    }
  }
}

/* eslint-disable */
export function validatePassword(rule, value, callback) {
  if (value === '') {
    callback(
      new Error(
        '密码为6-30个字符，必须同时包含：大小写英文字母、数字、特殊字符(`~!@#$%^&*_+()￥=-、|[]{};:\\\'")',
      ),
    );
  } else {
    const reg =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*_+()￥\=\-、|\\\[\]\{\};:\'‘”",\.<>《》\/\?。])[A-Za-z\d~!@#$%^&*_+()￥\=\-、|\\\[\]\{\};:\'‘”",\.<>《》\/\?。]{6,30}/g;
    if (!(reg.test(value) && value.length <= 30)) {
      callback(
        new Error(
          '密码为6-30个字符，必须同时包含:大小写英文字母、数字、特殊字符(`~!@#$%^&*_+()￥=-、|[]{};:\\\'")',
        ),
      );
    } else {
      callback();
    }
  }
}
